import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import Medias from 'components/UI/Media/Medias';

const MediasStyled = withStyles((theme) => ({
  root: {},
  paperWrapper: {
    width: '100%',
    display: 'block',
    position: 'relative',
    fontWeight: 'bold',
    '&:before': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      content: "' '",
      // height: '160px',
      height: '160px',
      backgroundColor: theme.palette.secondary.dark,
      // backgroundImage: 'url('+require('assets/images/header_replay.jpg')+')',
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%',
      backgroundRepeat: 'no-repeat',
      zIndex: -1,
    },
  },
}))(Medias);

// class MediasWrapper extends Component {
//   render() {
//     return <Medias templateProps={{kind: 'fullWidth', maxWidth: 'auto'}}/>
//   }
// }

export default MediasStyled;
